<template>
  <div>
    <component :is="layout">
      <router-view @loadingDone="loadingDone" />
    </component>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutBlank from '@/layouts/LayoutBlank'
import LayoutDefault from '@/layouts/LayoutDefault'
import LayoutWebview from '@/layouts/LayoutWebview'

export default {
  name: 'Foldaz',

  components: {
    LayoutBlank,
    LayoutDefault,
    LayoutWebview
  },

  computed: {
    webviewActive () {
      return this.$store.state.webview.active
    },

    layout () {
      const defaultLayout = this.webviewActive ? 'webview' : 'default'

      return 'layout-' + (this.$route.meta.layout || defaultLayout)
    }
  },

  methods: {
    ...mapActions({
      loadingDone: 'app/loadingDone'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue